import LoadingButton from '@mui/lab/LoadingButton';
import { Box, SxProps } from '@mui/material';
import Stack from '@mui/material/Stack';

import KeyFeatures from '@webclient/components/upgrade-modal/components/card/key-features';
import {
  StyledCenteredStack,
  StyledStackWrapper,
} from '@webclient/components/upgrade-modal/components/card/styles';

import { Text } from '@knowz/knowz-ui';

type Props = React.PropsWithChildren<{
  title: string;
  subtitle: string;
  priceInfo: {
    priceLine: string;
    creditLine: string;
    cycle: string;
  };
  keyFeatures: string[];
  boldFeature: string;
  button: {
    text: string;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    isLoading: boolean;
  };
  badges: React.ReactNode[];
  DiscountBadge?: React.ReactNode;
  sx?: SxProps;
}>;

export default function Card({
  priceInfo,
  title,
  subtitle,
  keyFeatures,
  boldFeature,
  button,
  children,
  DiscountBadge,
  badges,
  sx,
}: Props) {
  return (
    <StyledStackWrapper
      sx={sx}
      gap={3}
    >
      <StyledCenteredStack>
        {children && <Box sx={{ marginBlockEnd: 3 }}>{children}</Box>}
        <Text
          variant="displaySm"
          weight="bold"
        >
          {title}
        </Text>
        <Text
          variant="textSm"
          color="text.tertiary"
        >
          {subtitle}
        </Text>
        <KeyFeatures
          keys={keyFeatures}
          boldFeature={boldFeature}
          badges={badges}
        />
      </StyledCenteredStack>
      <Stack
        gap={4}
        sx={{ textAlign: 'center' }}
      >
        <StyledCenteredStack gap={2}>
          {DiscountBadge}
          <Stack
            direction="row"
            gap={2}
          >
            <Stack
              direction="row"
              sx={{ justifyContent: 'center' }}
              gap={1}
            >
              <Text
                variant="textMd"
                weight="medium"
              >
                US
              </Text>
              <Text
                variant="displayLg"
                weight="semibold"
              >
                ${priceInfo.priceLine}
              </Text>
            </Stack>
            <Text
              variant="textXs"
              color="text.secondary"
              sx={{ textAlign: 'left' }}
            >
              /{priceInfo.cycle}
              <br />
              {priceInfo.creditLine}
            </Text>
          </Stack>
        </StyledCenteredStack>
        <LoadingButton
          variant="contained"
          size="large"
          fullWidth
          loading={button.isLoading}
          onClick={button.onClick}
        >
          {button.text}
        </LoadingButton>
      </Stack>
    </StyledStackWrapper>
  );
}
